import common from './common.translation'
import commonLabels from './common-labels.translation'
import commonMessages from './common-messages.translation'

import sidebar from './sidebar.translation'
import login from './login.translation'
import users from './users.translation'

import wallet from './wallets.translation'
import error from './error.translation'
import bonusEngine from './bonus-engine.translation'

import pages from './pages.translation'
import transaction from './transactions.translation'
import reports from './reports.translation'

import personalizationEngine from './personalization-engine.translation'
import playerCard from './player-card.translation'

/**
 * SET TRANSLATIONS BY MODULE
 */
const EN_US = {
  translation: {
    ...wallet,
    ...bonusEngine,
    ...common,
    ...commonLabels,
    ...commonMessages,
    ...error,
    ...login,
    ...pages,
    ...personalizationEngine,
    ...sidebar,
    ...users,
    ...transaction,
    ...reports,
    ...playerCard,
  },
}

export default EN_US
